import { ButtonColor } from '@design-system/components/button/button.css';
import { IconButton } from '@design-system/components/button/iconButton';
import { Typography } from '@design-system/components/typography/typography';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export const Header = ({
  title,
  cta,
}: {
  title: string;
  link?: string;
  cta?: Array<{
    icon: IconProp;
    onClick: () => void;
    content?: string;
    className?: string;
    disabled?: boolean;
    color?: ButtonColor;
  }>;
}) => (
  <div className="flex flex-col md:flex-row justify-between">
    <Typography variant="headline" size="large">
      {title}
    </Typography>
    {!cta ? null : (
      <div className="flex gap-4">
        {cta.map((item, index) => (
          <IconButton
            key={index}
            disabled={item.disabled}
            icon={item.icon}
            color={item.color || 'neutral'}
            onClick={item.onClick}
          >
            {item.content || null}
          </IconButton>
        ))}
      </div>
    )}
  </div>
);
